import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import PlayerCard from "./PlayerCard";
import { Download, X } from "lucide-react";
import { useRef } from "react";
import html2canvas from "html2canvas";

const PlayerCardDialog = ({ open, onOpenChange, user }) => {
  const cardRef = useRef(null);

  const handleDownload = async () => {
    if (!cardRef.current) return;
    try {
      const canvas = await html2canvas(cardRef.current, {
        scale: 2,
        useCORS: true,
        backgroundColor: '#ffffff',
      });
      const link = document.createElement('a');
      link.download = `${user?.name || 'oyuncu'}-kart.png`;
      link.href = canvas.toDataURL('image/png');
      link.click();
    } catch (err) {
      console.error('Kart indirme hatası:', err);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent 
        className="max-w-sm border-0 shadow-none [&>button]:hidden"
        style={{ 
          backgroundColor: 'transparent',
          maxHeight: '80vh',
          display: 'flex',
          flexDirection: 'column',
          gap: '8px',
          padding: '0',
          overflow: 'hidden',
        }}
      >
        <button
          onClick={() => onOpenChange(false)}
          className="absolute -top-1 -right-1 z-50 w-7 h-7 rounded-full flex items-center justify-center transition-colors"
          style={{ background: 'rgba(0,0,0,0.35)', color: 'rgba(255,255,255,0.6)' }}
          data-testid="player-card-close-btn"
        >
          <X className="h-3.5 w-3.5" />
        </button>

        <div 
          className="overflow-y-auto flex-1 rounded-xl"
          style={{ minHeight: 0 }}
        >
          <div ref={cardRef}>
            <PlayerCard user={user} />
          </div>
        </div>

        <div className="flex gap-2 w-full shrink-0 px-1 pb-1">
          <Button 
            variant="outline" 
            className="flex-1 bg-white/90 dark:bg-[#2a2d2f] dark:border-[#3a3d40]"
            onClick={handleDownload}
            data-testid="player-card-download-btn"
          >
            <Download className="h-4 w-4 mr-2" />
            İndir
          </Button>
          <Button 
            className="flex-1 text-white border-0"
            style={{ background: 'rgba(147, 112, 219, 0.7)' }}
            onClick={() => onOpenChange(false)}
            data-testid="player-card-close-action"
          >
            Kapat
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PlayerCardDialog;
